import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Modal , Menu, Button, Row, Col, Input, Form, Icon, message,Card, Upload, notification} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import SparkOpportunityForm from '../Inc/SparkOpportunityForm';


class AlumniHelpReportIssue extends Component {
  constructor(props){
    super(props)
    this.state = {
      isShowSPARK_OpportunityModal: false,
    }
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  ShowSPARK_OpportunityModal = () => {
    this.setState({
        isShowSPARK_OpportunityModal: true
    })
  }

  hideSPARK_OpportunityModal = () => {
    this.setState({
        isShowSPARK_OpportunityModal: false
    })
  }

  render () {
    const { location } = this.props;
    return (
      <div>
        <LayoutHeader />

        <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ alignItems: "end", display: "Flex", justifyContent: "end"  }}>
          <Menu.Item key="/alumni-dashboard"> 
            <NavLink to="/alumni-dashboard">
              <button className='Need-help-action'>CLOSE <i class="fa fa-window-close" aria-hidden="true"></i></button>  
            </NavLink>
          </Menu.Item>
        </Menu>

        <div className='Alumni-NeedHelp-Container'>
          <div className='Alumni-NeedHelp-Greeting-reportissue'>
            The <Button onClick={() => {this.ShowSPARK_OpportunityModal()}} type="link" className='Alumni-NeedHelp-Form-Link' > Spark User Feedback form </Button> is 
            a communication path to alert program managers of any type of issue incurred when 
            visiting the Spark directory site.
          </div>
        </div>

        <SparkOpportunityForm 
          hideSPARK_OpportunityModalHandler = {this.hideSPARK_OpportunityModal}
          // handleSubmitHandler = {this.handleSubmit}
          isShowSPARK_OpportunityModal = {this.state.isShowSPARK_OpportunityModal}
        />
      </div>
    )
  }


}

function mapStateToProps(state) {
  return {
    isadmin: state.isadminreducer.isadmin,
    isSendingMail: state.sparkOpportunityFormReducer.isSendingMail,
    mailSent: state.sparkOpportunityFormReducer.mailSent,
    mailFailed: state.sparkOpportunityFormReducer.mailFailed,
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(AlumniHelpReportIssue));


// WEBPACK FOOTER //
// ./src/components/AlumniHelp/AlumniHelpReportIssue.js